<template>
  <div class="eventComp_mode_24 eventComp_mode_container" v-show="currThemeObj">
    <div class="tableScrollArea" ref="tableParentDom">
      <multiLevelFold_table
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsId="currSportsDetail.sportsId"
        :tabType="tabType"
        :tableMode="tableMode"
        :parentWidthPx="parentWidthPx"
        :isScrollFlag="isScrollFlag"
        :variableColWidthVw="variableColWidthVw"
        :tableCellDefaultWidthVw="tableCellDefaultWidthVw"
        :defaultWidthVwNum="defaultWidthVwNum"
        :tableColumnData="tableColumnData"
        :tableData="tableData"
        @toParentEvent="toParentEventHandler"
        v-show="tableData && tableData.length > 0"
      ></multiLevelFold_table>
    </div>
  </div>
</template>

<script>
// 适用： 亚运会非对抗类 赛果 动态列表格 （大运会18个项目以外用这个）
import multiLevelFold_table from '@components/platfromBase/compreSportsMeet/table/multiLevelFold_table.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'eventComp_mode_24',
  components: {
    multiLevelFold_table,
  },
  props: {
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    datas: {
      type: Object,
      default: () => ({}),
    },
    tabType: {
      type: String, //确定数据来自于 出场名单'startList'  || 本场数据'localData',
      default: '',
    },
    competitorType: {
      type: String, //竞赛者的类型 A || D || T,
      default: '',
    },
    isCombatFlag: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [cup_base_data_mixin],
  watch: {
    datas: {
      handler(newVal, oldVal) {
        console.debug('mode_24 刷新数据:', newVal, oldVal)
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          this.init()
        }
      },
      //   immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      isScrollBottom: false,
      tableMode: 'eventComp_mode_24',
      parentWidthPx: 0,
      parentHeightPx: 0,
      isScrollFlag: false,
      isClickFlag: false,
      variableColWidthVw: 13.88,
      tableCellDefaultWidthVw: null,
      defaultWidthVwNum: null,
      tableColumnData: [],
      tableData: null,
      tableTotal: 0,
      currModeObj: null,
      customColKeys: [
        '运动员',
        '姓名',
        '国家/地区',
        '竞赛者',

        '号码',
        '序号',
        '排名',
        '顺序',
        '出场顺序',
      ],
      renderModeList: [
        {
          modeName: '', //从0开始计算
          sportsIdArr: [
            'WTL',
            'WSU',
            'CLB',
            'JJI',
            'WRE',
            'MGO',
            'XQI',
            'CHS',
            'SWA',
            'ROL',
            'SRF',

            'BMX',
            'FBL',
            'BRK',
            'BKG',
            'BRE',
            'CRD',
            'ELS',
            'OWS',
            'GTR',
            'MTB',
            'KTE',
            'WLF',
            'CSL',
            'CSP',
            'CTR',
            'DGB',
            'GLF',
            'KAB',
            'BDG',
            'TRI',
            'MPN',
            'SKB',
            'EQU',
            'BMF',
            'SAL',
          ],
          variableColWidthVw: [
            27.76, 27.76, 27.76, 27.76, 27.76, 27.76, 27.76, 27.76, 27.76,
            27.76, 27.76, 27.76, 27.76, 27.76, 27.76, 27.76, 27.76, 27.76,
            27.76, 27.76, 27.76, 27.76, 27.76, 27.76, 27.76, 27.76, 27.76,
            27.76, 27.76, 16.8, 27.76, 27.76, 27.76, 27.76, 27.76, 27.76,
          ],
          firstDynamicsColWidthVw: [
            11.1, 11.1, 11.1, 11.1, 11.1, 11.1, 11.1, 11.1, 11.1, 11.1, 11.1,
            11.1, 11.1, 11.1, 11.1, 11.1, 11.1, 11.1, 11.1, 11.1, 11.1, 11.1,
            11.1, 11.1, 11.1, 11.1, 11.1, 11.1, 11.1, 9.74, 11.1, 11.1, 11.1,
            11.1, 11.1, 11.1,
          ],
          tableCellDefaultWidthVw: [
            5.55,
            5.55,
            5.55,
            5.55,
            5.55,
            5.55,
            5.55,
            5.55,
            5.55,
            5.55,
            5.55,

            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
          ],
          isTabType: '',
        },
        {
          // 马术：团体成绩
          modeName: '',
          defaultInsertCustomColuIndex: 0, //在第0个后插入
          variableColWidthVw: [27.76],
          firstDynamicsColWidthVw: [11.1],
          tableCellDefaultWidthVw: [null],
          sportsIdArr: ['EQU'],
          isTabType: 'teamResult',
          resultKey: 'result_team',
        },
        {
          // 马术: 个人成绩
          // 轮滑: 本场数据
          // 武术: 本场数据
          // 帆船: 本场数据
          modeName: '',
          defaultInsertCustomColuIndex: 0, //在第0个后插入
          variableColWidthVw: [27.76, 27.76, 27.76, 27.76, 27.76],
          firstDynamicsColWidthVw: [11.1, 11.1, 11.1, 11.1, 11.1],
          tableCellDefaultWidthVw: [null, 5.55, 5.55, 5.55, 5.55],
          sportsIdArr: ['EQU', 'ROL', 'WSU', 'SAL', 'WTL'],
          isTabType: 'singleResult',
          resultKey: 'result_single',
        },
      ],
      coustomSports_tableCellDefaultWidthVw: {
        //先判断常规列数，大于等于6则走这个逻辑；部分大于2且小于6的也走这里
        sportsIdArr: [
          'WTL',
          'WSU',
          'CLB',
          'WLF',
          'GLF',
          'KAB',
          'JJI',
          'WRE',
          'MGO',
          'XQI',
          'CHS',
          'SWA',
          'ROL',
        ],
      },
    }
  },
  beforeCreate() {},
  mounted() {
    window.addEventListener('resize', () => {
      this.onResizeEvent()
    })
    this.init()
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.onResizeEvent()
    })
  },
  methods: {
    async init() {
      this.$nextTick(() => {
        this.onResizeEvent()
        if (this.currSportsDetail && this.currSportsDetail.sportsId) {
          this.renderModeList.forEach((modeItem) => {
            if (modeItem.isTabType) {
              if (
                modeItem.sportsIdArr.includes(this.currSportsDetail.sportsId) &&
                modeItem.isTabType === this.tabType
              ) {
                this.currModeObj = modeItem
              }
            } else {
              if (
                modeItem.sportsIdArr.includes(this.currSportsDetail.sportsId)
              ) {
                this.currModeObj = modeItem
              }
            }
          })
        }
        console.debug(
          'mode_24 tabType:',
          this.tabType,
          this.datas,
          this.competitorType
        )

        // this.computedModeData(JSON.parse(JSON.stringify(this.datas)))
        // const datas = {
        //   data: [
        //     {
        //       start_order: 1,
        //       player_id: 'DIVMS2406000',
        //       player_name: '杨凌',
        //       player_logo:
        //         'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/participants/DIV/DIVMS2406000.jpg',
        //       player_gender: 'M',
        //       player_birth_date: '2001-06-06',
        //       team_id: 'CHN',
        //       team_name: '中国',
        //       team_logo:
        //         'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/organisations/CHN.png',
        //     },
        //     {
        //       start_order: 2,
        //       player_id: 'DIVMS2406007',
        //       player_name: '王彬翰',
        //       player_logo:
        //         'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/participants/DIV/DIVMS2406007.jpg',
        //       player_gender: 'M',
        //       player_birth_date: '2004-09-13',
        //       team_id: 'CHN',
        //       team_name: '中国',
        //       team_logo:
        //         'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/organisations/CHN.png',
        //     },
        //     {
        //       start_order: 9,
        //       player_id: 'DIVMS2405967',
        //       player_name: '黄子淦',
        //       player_logo:
        //         'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/participants/DIV/DIVMS2405967.jpg',
        //       player_gender: 'M',
        //       player_birth_date: '1999-04-05',
        //       team_id: 'CHN',
        //       team_name: '中国',
        //       team_logo:
        //         'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/organisations/CHN.png',
        //     },

        //     {
        //       start_order: 4,
        //       player_id: 'DIVMS2403379',
        //       player_name: '金志旭',
        //       player_logo:
        //         'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/participants/DIV/DIVMS2403379.jpg',
        //       player_gender: 'M',
        //       player_birth_date: '2001-03-26',
        //       team_id: 'KOR',
        //       team_name: '韩国',
        //       team_logo:
        //         'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/organisations/KOR.png',
        //     },
        //     {
        //       start_order: 5,
        //       player_id: 'DIVMS2403394',
        //       player_name: '申政伟',
        //       player_logo:
        //         'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/participants/DIV/DIVMS2403394.jpg',
        //       player_gender: 'M',
        //       player_birth_date: '2001-11-15',
        //       team_id: 'KOR',
        //       team_name: '韩国',
        //       team_logo:
        //         'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/organisations/KOR.png',
        //     },
        //     {
        //       start_order: 8,
        //       player_id: 'DIVMS2403393',
        //       player_name: '姜旻赫',
        //       player_logo:
        //         'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/participants/DIV/DIVMS2403393.jpg',
        //       player_gender: 'M',
        //       player_birth_date: '2003-05-28',
        //       team_id: 'KOR',
        //       team_name: '韩国',
        //       team_logo:
        //         'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/organisations/KOR.png',
        //     },
        //     {
        //       start_order: 6,
        //       player_id: 'DIVMS2402574',
        //       player_name: '卢贝',
        //       player_logo:
        //         'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/participants/DIV/DIVMS2402574.jpg',
        //       player_gender: 'M',
        //       player_birth_date: '1996-11-22',
        //       team_id: 'GER',
        //       team_name: '德国',
        //       team_logo:
        //         'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/organisations/GER.png',
        //     },
        //     {
        //       start_order: 12,
        //       player_id: 'DIVMS2402580',
        //       player_name: '瓦尔德斯泰纳',
        //       player_logo:
        //         'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/participants/DIV/DIVMS2402580.jpg',
        //       player_gender: 'M',
        //       player_birth_date: '2002-05-15',
        //       team_id: 'GER',
        //       team_name: '德国',
        //       team_logo:
        //         'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/organisations/GER.png',
        //     },
        //     {
        //       start_order: 7,
        //       player_id: 'DIVMS2404089',
        //       player_name: '曼恩',
        //       player_logo:
        //         'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/participants/DIV/DIVMS2404089.jpg',
        //       player_gender: 'M',
        //       player_birth_date: '2002-11-15',
        //       team_id: 'USA',
        //       team_name: '美国',
        //       team_logo:
        //         'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/organisations/USA.png',
        //     },
        //     {
        //       start_order: 3,
        //       player_id: 'DIVMS2401376',
        //       player_name: '西田玲央',
        //       player_logo:
        //         'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/participants/DIV/DIVMS2401376.jpg',
        //       player_gender: 'M',
        //       player_birth_date: '2000-07-16',
        //       team_id: 'JPN',
        //       team_name: '日本',
        //       team_logo:
        //         'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/organisations/JPN.png',
        //     },
        //     {
        //       start_order: 10,
        //       player_id: 'DIVMS2401394',
        //       player_name: '兼戸凯',
        //       player_logo:
        //         'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/participants/DIV/DIVMS2401394.jpg',
        //       player_gender: 'M',
        //       player_birth_date: '2001-02-13',
        //       team_id: 'JPN',
        //       team_name: '日本',
        //       team_logo:
        //         'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/organisations/JPN.png',
        //     },
        //     {
        //       start_order: 11,
        //       player_id: 'DIVMS2405590',
        //       player_name: '马尔吉奥托·迪亚斯',
        //       player_logo:
        //         'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/participants/DIV/DIVMS2405590.jpg',
        //       player_gender: 'M',
        //       player_birth_date: '2002-07-08',
        //       team_id: 'BRA',
        //       team_name: '巴西',
        //       team_logo:
        //         'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/organisations/BRA.png',
        //     },
        //   ],
        //   table_head: [
        //     {
        //       name: '顺序',
        //       desc: '',
        //       map_key_arr: ['start_order'],
        //     },
        //     {
        //       name: '国家',
        //       desc: '',
        //       map_key_arr: ['team_name'],
        //     },
        //     {
        //       name: '姓名',
        //       desc: '',
        //       map_key_arr: [
        //         'player_name',
        //         'player_logo',
        //         'player_gender',
        //         'player_birth_date',
        //         'team_name',
        //         'team_logo',
        //       ],
        //     },
        //     {
        //       name: '性别',
        //       desc: '',
        //       map_key_arr: ['player_gender'],
        //     },
        //     {
        //       name: '名字',
        //       desc: '',
        //       map_key_arr: ['player_name'],
        //     },
        //     {
        //       name: '性别',
        //       desc: '',
        //       map_key_arr: ['player_gender'],
        //     },
        //     {
        //       name: '名字',
        //       desc: '',
        //       map_key_arr: ['player_name'],
        //     },
        //     {
        //       name: '生日',
        //       desc: '',
        //       map_key_arr: ['player_birth_date'],
        //     },
        //   ],
        //   judge: null,
        // }

        console.log('this.currModeObj', this.currModeObj)

        const datas =
          this.currModeObj.isTabType && this.datas[this.currModeObj.resultKey]
            ? this.datas[this.currModeObj.resultKey]
            : this.datas
        let mergeObj = null
        if (
          this.currSportsDetail.eventId === 'EQUOEVEN--------------------------'
        ) {
          // 赛果的 A|D|T类型不对，需要特殊处理
          // 需要把 competitorType T 变成 A，原因如下：
          // 马术的团体及个人，里面的个人成绩要把 competitorType 从 T 换成 A，因为这场比赛赛果里面既有单人也有团体，而赛果数据中 competitorType = 'T'，所以展示【个人成绩】的没有办法展示运动员信息，因此要特殊处理
          mergeObj = { competitorType: 'A' }
        }
        this.computedModeData(JSON.parse(JSON.stringify(datas)), mergeObj)
      })
    },
    toParentEventHandler(data) {
      console.debug(data)
    },
    onResizeEvent() {
      if (this.$refs.tableParentDom) {
        this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      } else {
        console.debug('dom 不存在')
      }
    },
    computedModeData(data, mergeObj) {
      let competitorType =
        mergeObj && mergeObj.competitorType
          ? mergeObj.competitorType
          : this.competitorType
      let customColumn = null
      let customNum = 0
      console.debug(
        'computedModeData:',
        data,
        this.currModeObj,
        mergeObj,
        competitorType
      )

      if (
        this.currModeObj.variableColWidthVw &&
        this.currModeObj.variableColWidthVw.length > 0
      ) {
        const index = this.currModeObj.sportsIdArr.indexOf(
          this.currSportsDetail.sportsId
        )
        console.debug('index 11:', index)
        this.variableColWidthVw = this.currModeObj.variableColWidthVw[index]
        this.firstDynamicsColWidthVw =
          this.currModeObj.firstDynamicsColWidthVw[index]
      }

      const table_headArr = data.table_head || []

      // 表头
      const headColumns = []
      table_headArr.forEach((colums, colIndex) => {
        if (colums && colums.map_key_arr.length > 0) {
          if (this.customColKeys.includes(colums.name)) {
            customNum++
          }
          headColumns.push({
            colKey: colums.map_key_arr[0] ? colums.map_key_arr[0] : '',
            colTitle: colums.name ? colums.name : '',
            fixed: colums.fixed ? colums.fixed : '',
          })
        }
      })

      const otherColumns = headColumns

      this.defaultWidthVwNum = otherColumns.length - customNum //减去自定义列[运动员]

      if (this.defaultWidthVwNum === 0 || this.defaultWidthVwNum < 6) {
        this.variableColWidthVw = null
      }
      let otherColumWdithVw = null
      if (this.defaultWidthVwNum >= 6) {
        this.tableCellDefaultWidthVw = 6.94
        otherColumWdithVw = this.tableCellDefaultWidthVw
        this.isScrollFlag = true
      } else {
        if (this.defaultWidthVwNum <= 2) {
          // 兼容【武术，攀岩】 非对抗类普通和非对抗类全能
          this.tableCellDefaultWidthVw = null
          otherColumWdithVw = this.tableCellDefaultWidthVw
          console.debug(
            'this.defaultWidthVwNum:',
            this.tableCellDefaultWidthVw,
            this.defaultWidthVwNum
          )
          if (this.defaultWidthVwNum == 2) {
            // 兼容 【围棋】团体本场数据
            let defaultWidthVwIndex = this.currModeObj.sportsIdArr.indexOf(
              this.currSportsDetail.sportsId
            )
            if (defaultWidthVwIndex > -1) {
              this.variableColWidthVw =
                this.currModeObj.variableColWidthVw[defaultWidthVwIndex]
            }
          }
        } else if (
          !otherColumWdithVw &&
          this.coustomSports_tableCellDefaultWidthVw.sportsIdArr.includes(
            this.currSportsDetail.sportsId
          )
        ) {
          let defaultWidthVwIndex = this.currModeObj.sportsIdArr.indexOf(
            this.currSportsDetail.sportsId
          )
          if (defaultWidthVwIndex > -1) {
            this.tableCellDefaultWidthVw =
              this.currModeObj.tableCellDefaultWidthVw[defaultWidthVwIndex]
            otherColumWdithVw = this.tableCellDefaultWidthVw
            if (otherColumWdithVw) {
              this.variableColWidthVw =
                this.currModeObj.variableColWidthVw[defaultWidthVwIndex]
            }
          }
        } else {
          this.tableCellDefaultWidthVw = null
        }
      }
      if (this.variableColWidthVw === this.tableCellDefaultWidthVw) {
        this.defaultWidthVwNum++ //因为【this.variableColWidthVw === this.tableCellDefaultWidthVw】，所以defaultWidthVwNum列个数要+1
      }

      if (competitorType === 'T') {
        // 对抗类 团体走这里
        customColumn = {
          prop: 'teamLogo-teamName', //fristColumnPropArr.join('-'),
          label: '国家/地区',
          widthVw: this.variableColWidthVw,
          className: 'columnTeamLogoTeamNameClass', //单独定制的头部样式class
          // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
        }
      } else if (competitorType === 'A') {
        let playerProp = 'singlePlayer-team'
        let playerClassName = 'columnPlayerGroupClass'
        customColumn = {
          prop: playerProp, //fristColumnPropArr.join('-'),
          label: '运动员',
          widthVw: this.variableColWidthVw,
          className: playerClassName, //单独定制的头部样式class
          // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
        }
      } else if (competitorType === 'D') {
        let playerProp = 'teamLogo-teamName-playerListString'
        let playerClassName = 'columnPlayerGroupClass'
        customColumn = {
          prop: playerProp, //fristColumnPropArr.join('-'),
          label: '运动员',
          widthVw: this.variableColWidthVw,
          className: playerClassName, //单独定制的头部样式class
          // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
        }
      } else {
      }

      if (this.tableColumnData.length == 0) {
        let tableColumnData = []
        console.debug('otherColumns:', otherColumns, customColumn)
        for (let i = 0; i < otherColumns.length; i++) {
          const item = otherColumns[i]
          const customIndex = this.customColKeys.indexOf(item.colTitle)
          if (customIndex > -1) {
            // 特殊列
            if (customIndex > -1 && customIndex < 4) {
              if (competitorType !== 'T') {
                customColumn.label = item.colTitle
              }
              customColumn.fixed = item.fixed ? item.fixed : ''
              tableColumnData.push(customColumn)
            } else {
              let className = ''
              tableColumnData.push({
                prop: item.colKey,
                label: item.colTitle,
                widthVw: this.firstDynamicsColWidthVw,
                className,
                selected: '',
                fixed: item.fixed ? item.fixed : '',
              })
            }
          } else {
            // 普通列
            let className = ''
            tableColumnData.push({
              prop: item.colKey,
              label: item.colTitle,
              widthVw: otherColumWdithVw,
              className,
              selected: '',
              fixed: item.fixed ? item.fixed : '',
            })
          }
        }

        console.debug(
          'this.defaultWidthVwNum:',
          this.tableCellDefaultWidthVw,
          this.defaultWidthVwNum,
          otherColumns,
          customNum,
          tableColumnData,
          this.isScrollFlag
        )
        this.tableColumnData = tableColumnData
      }

      if (this.isCombatFlag) {
        // 对抗类 团体走这里, data:{away:[], home:[], table_head:[]}
        // customColumn = {
        //   prop: 'teamLogo-teamName', //fristColumnPropArr.join('-'),
        //   label: '国家/地区',
        //   width: this.variableColWidthVw,
        //   className: 'columnTeamLogoTeamNameClass', //单独定制的头部样式class
        //   // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
        // }
        if (data && data.table_head) {
          const dataList = [].concat(data.home, data.away)
          this.tableTotal = dataList ? dataList.length : 0

          this.tableData = dataList.map((rowData) => {
            if (rowData.is_win === false) {
              rowData.is_win = '负'
            } else if (rowData.is_win === true) {
              rowData.is_win = '胜'
            }
            return rowData
          })
          // this.$refs.tableParentDom.scrollTo(0, 0)
          console.debug('this.tableData:', this.tableData, this.tableColumnData)
        } else {
          console.debug('暂无数据')
          this.notDataHandler()
        }
      } else {
        // 非对抗类（A|D|T）, data:{data:[], table_head:[]}
        if (data && data.data) {
          this.tableTotal = data ? data.length : 0
          this.tableData = data.data.map((rowData) => {
            return rowData
          })
          // this.$refs.tableParentDom.scrollTo(0, 0)
          console.debug('this.tableData:', this.tableData, this.tableColumnData)
        } else {
          console.debug('暂无数据')
          this.notDataHandler()
        }
      }
    },
    notDataHandler() {
      this.tableTotal = 0
      this.tableData = []
    },
  },
}
</script>

<style lang="scss" scoped>
.eventComp_mode_container {
  padding: 1.388vw 0;
  .tableScrollArea {
    position: relative;
    width: 100%;
  }
}
</style>
